<fuse-widget class="widget p-0 h-100-p" fxLayout="column" fxLayoutAlign="space-between center" fxFlex="100">

  <!-- Front -->
  <div class="fuse-widget-front mat-white-bg mat-elevation-z2 h-100-p clickable" (click)="click()">
    <div class="px-16 py-16 h-52" fxLayout="row" fxLayoutAlign="space-between center">
      <div class="h3" fxFlex>{{title}}</div>
    </div>
    <div class="count">
      <div class="pt-4 pb-12" fxLayout="column" fxLayoutAlign="center center" fxFlex='1 0 auto' matTooltip="Click to view list">
        <div class="font-size-72 line-height-72" [style.color]="color">
          {{count}}
        </div>
        <div class="h3 secondary-text font-weight-500 px-16" style="text-align: center;" matTooltip="{{label}}">{{label}}</div>
      </div>

      <div *ngIf="extralabel" class="p-12 grey-50-bg border-top not-clickable" fxLayout="row" fxLayoutAlign="start center" (click)="extraClick($event)">
        <span class="h4 secondary-text text-truncate" matTooltip="{{extralabel}}">
          {{extralabel}}:
        </span>
        <span class="h4 ml-8">{{extracount}}</span>
      </div>
    </div>
  </div>
  <!-- / Front -->
  <!-- Back -->
  <!-- 3/1/19 Reverse of cards removed -->
  <!-- / Back -->

</fuse-widget>
